import PropTypes from 'prop-types'

import defaultProps from '@/components/Form/defaultProps'
import Field from '@/components/Form/Field'
import propTypes from '@/components/Form/propTypes'
import cn from '@/utilities/cn'

import './index.scss'

import { omit } from 'lodash'
import { Dropdown } from 'semantic-ui-react'

const handleBlur = (formik: any, onBlur: any) => {
  return (e: any, data: any) => {
    formik.setFieldTouched(data.name || data.id, true)
    if (onBlur) onBlur({ ...e, target: { ...data } })
  }
}

const handleChange = (formik: any, onChange: any) => {
  return (e: any, data: any) => {
    formik.setFieldValue(data.name || data.id, data.value)
    if (onChange) onChange({ ...e, target: { ...data } })
  }
}
/**
 * A filter select using the Semantic UI React, which allows you to use the other field attributes that a dropdown would allow
 *
 * @example
 * <FilterSelect
 *   description={<FormattedMessage id="SomeDescription" defaultMessage="Some Select" options={[{key:'key', value:'value', text:'text to display'}]}/>}
 *   label={<FormattedMessage id="SomeLabel" defaultMessage="Some Label" />}
 *   name="someField"
 *   required
 * >
 */
const FilterSelect = ({ options, className, onChange, search = true, onBlur, defaultValue, ...props }: any) => {
  const fieldProps = omit(props, 'value')
  return (
    <Field
      {...fieldProps}
      className={cn('form__filter-select', className)}
      render={({ formik, ...field }: any) => {
        return (
          <div className="field__wrapper">
            <Dropdown
              {...field}
              fluid
              search={search}
              upward={false}
              selection
              options={options}
              onBlur={handleBlur(formik, onBlur)}
              onChange={handleChange(formik, onChange)}
              defaultValue={defaultValue}
            />
          </div>
        )
      }}
    />
  )
}

FilterSelect.displayName = 'FilterSelect'

FilterSelect.propTypes = {
  ...propTypes,
  defaultValue: PropTypes.any,
  value: PropTypes.any,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  multiple: PropTypes.bool,
  closeOnChange: PropTypes.bool,
  noResultsMessage: PropTypes.node,
  placeholder: PropTypes.node,
  allowAdditions: PropTypes.bool
}

FilterSelect.defaultProps = {
  ...defaultProps
}

export default FilterSelect
